<template>
<div>
  <div class="container-fluid  pb-5">
      <div class="row pb-4">
          <div class="col col-lg-8 offset-lg-2 px-5 mt-5">
            <h1>Aviso de Privacidad</h1>

            <p class="mt-5 text-justify">Nao Cruises S.A.P.I. de C.V. (en lo sucesivo “Nao Travel Collection”), con domicilio en Boulevard Manuel Ávila Camacho No. 184-PB, Ciudad de México, C.P., es responsable del uso y protección de tus datos personales.</p>

            <h2 class="subtitle">Datos personales que recabamos</h2>
            <p class="text-justify">Los datos personales que podremos recabar de manera directa o indirecta incluyen, de forma enunciativa mas no limitativa:</p>
            <ul>
              <li>Nombre completo</li>
              <li>Correo electrónico</li>
              <li>Número telefónico</li>
              <li>Empresa y puesto laboral</li>
              <li>Información de contacto adicional necesaria para la prestación de nuestros servicios</li>
            </ul>
            <p class="text-justify">Nao Travel Collection no recaba datos personales sensibles.</p>

            <h2 class="subtitle">Finalidades del tratamiento</h2>
            <p class="text-justify">Los datos personales que recabamos se utilizan para las siguientes finalidades:</p>
            <h3 class="subtitle">Primarias (necesarias para el servicio)</h3>
            <ul>
              <li>Registrarte en nuestro Newsletter y dar seguimiento a tu suscripción.</li>
              <li>Enviar comunicaciones relacionadas con nuestros servicios, capacitaciones y eventos.</li>
              <li>Atender solicitudes, preguntas o comentarios sobre nuestros servicios.</li>
              <li>Notificar cambios a este Aviso de Privacidad.</li>
            </ul>
            <h3 class="subtitle">Secundarias (opcional)</h3>
            <p class="text-justify">Enviar promociones, información comercial y material de marketing de Nao Travel Collection y sus socios comerciales. Si no deseas que tus datos se utilicen para finalidades secundarias, puedes indicarlo enviando un correo a <a href="mailto:newsletter@naotravelco.com">newsletter@naotravelco.com</a>.</p>

            <h2 class="subtitle">Uso de cookies y tecnologías similares</h2>
            <p class="text-justify">Te informamos que nuestro sitio web utiliza cookies y tecnologías de rastreo que permiten obtener información de manera automática, como dirección IP, navegador utilizado, tiempo de permanencia en el sitio y páginas visitadas. Estas tecnologías se utilizan con fines estadísticos, de seguridad y para mejorar tu experiencia de navegación. Puedes deshabilitarlas desde la configuración de tu navegador; sin embargo, al hacerlo algunas funciones del sitio pueden verse limitadas.</p>

            <h2 class="subtitle">Transferencia de datos</h2>
            <p class="text-justify">Nao Travel Collection no compartirá tus datos personales con terceros sin tu consentimiento, salvo en los casos previstos por la Ley, como requerimientos de autoridad competente.</p>

            <h2 class="subtitle">Derechos ARCO y revocación del consentimiento</h2>
            <p class="text-justify">Tienes derecho a Acceder, Rectificar, Cancelar u Oponerte al uso de tus datos personales (Derechos ARCO), así como a revocar el consentimiento otorgado. Para ejercer estos derechos, deberás enviar una solicitud a <a href="mailto:newsletter@naotravelco.com">newsletter@naotravelco.com</a> que incluya al menos:</p>
            <ul>
              <li>Tu nombre y medio para comunicarte la respuesta (correo electrónico o domicilio).</li>
              <li>Copia de un documento que acredite tu identidad (INE, pasaporte) o, en su caso, documento que acredite la representación legal.</li>
              <li>Una descripción clara de los datos respecto de los que buscas ejercer derechos ARCO.</li>
              <li>En su caso, documentos que faciliten la localización de los datos personales.</li>
            </ul>
            <p class="text-justify">Nao Travel Collection dará respuesta a tu solicitud en un plazo máximo de 20 días hábiles.</p>

            <h2 class="subtitle">Medidas de seguridad</h2>
            <p class="text-justify">Nao Travel Collection ha implementado medidas administrativas, técnicas y físicas para proteger tus datos personales contra daño, pérdida, alteración, destrucción o uso, acceso o tratamiento no autorizado.</p>

            <h2 class="subtitle">Cambios al Aviso de Privacidad</h2>
            <p class="text-justify">Este Aviso de Privacidad puede sufrir modificaciones por actualizaciones legales o internas. Te notificaremos cualquier cambio mediante nuestro sitio web <a href="https://www.naotravelco.com" target="_blank" rel="noopener">www.naotravelco.com</a> o por correo electrónico.</p>

            <p class="mt-4">Última actualización: Octubre 2025</p>
          </div>
      </div>
  </div>
    
  <!-- categorias -->
  
  <!-- products -->

  <!-- fin -->
</div>
</template>

<script>

export default {
  components: {  },
  data() {
    return {

    };
  },
  async mounted() {
    this.$isLoading(true)
  },
  methods: {
    scrollFix: function(hash) {
      setTimeout(() => {
        const el = document.querySelector('#'+hash)
        el && el.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }, 2000);
      // setTimeout(() => $('html, body').animate({
        
      // scrollTop: $('#'+hash).offset().top
      // }, 1000), 1)
    },        
    goto(url){
      if(url.includes('http')){
        console.log('web', url)
        window.open(url)
      }
      else{
        window.location.href =url
        console.log('in', url)
      }      
      // console.log('goto ruta: ', rutaWeb)
      // this.$router.push(rutaWeb)
    },    

    
  },
};
</script>
<style scoped>

.subtitle {
  font-weight: 700;
  margin-top: 2rem;
  margin-bottom: 1rem;
}

ul {
  margin-left: 1.5rem;
  margin-bottom: 1.5rem;
}

li {
  margin-bottom: 0.5rem;
}

.text-justify {
  text-align: justify;
}

</style>